define('GameDayCore/GDUtil/dataMapping/GameStateUtil',['require','exports','module','gameday-index-url-hasher/UrlHasher','extant/extant','gameday-index-enums/enums/baseball/GameStates','../../GDModel/enums/baseball/SimpleStatusCodes','../../GDControl/GameModelLocator/GameModelLocator','../../GDModel/enums/datasources/Datasources'],function(require,exports,module) {
    var UrlHasher = require("gameday-index-url-hasher/UrlHasher"),
        exists = require("extant/extant"),
		GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
        SimpleStatusCodes = require("../../GDModel/enums/baseball/SimpleStatusCodes"),
        GameModelLocator = require("../../GDControl/GameModelLocator/GameModelLocator"),
        Datasources = require("../../GDModel/enums/datasources/Datasources");

    function getStatus(data){
    	if(data){
    		return data;
    	}
		var gameData = GameModelLocator.getGameData(),
			ind;
		if(gameData.gameData){
			return gameData.gameData.status.statusCode;
		}
		return (gameData.play || gameData.linescore).status_ind;
    }

    exports.currentInning = 1;

	exports.getGameViewState = function(data){
		var viewState = this.getUsableGameState(getStatus(data));

		return (viewState !== GameStates.RE_SUSPENDED) ? viewState : GameStates.RE_LIVE;
	};

	exports.getUsableGameState = function(data,noLock){
		var ind = getStatus(data),
			state,
			hashParams = UrlHasher.getHashParams(),
			hasLock = hashParams.lock_state,
			primaryCode = ind.charAt(0),
			enumeratedCode = SimpleStatusCodes[primaryCode];

		if(hasLock && noLock!==true){
			return hasLock;
		}

		// Warmup
		if (ind === "PW") {
			return GameStates.RE_LIVE;
		}
		// Forfit or Delayed
		if (ind === "RK") {
			return GameStates.RE_PREGAME;
		}

		switch (true) {
			case !enumeratedCode :
			case enumeratedCode < SimpleStatusCodes.T :
				state = GameStates.RE_PREGAME;
				break;
			case enumeratedCode < SimpleStatusCodes.I :
				// This was dumb anyway
				// state = GameStates.RE_SUSPENDED;
				// break;
			case enumeratedCode < SimpleStatusCodes.O :
				state = GameStates.RE_LIVE;
				break;
			case enumeratedCode >= SimpleStatusCodes.O :
				state = GameStates.RE_WRAPUP;
				break;

			default:
				state = hashParams.game_state || UrlHasher.getCachedParams().game_state || GameStates.RE_PREGAME;
				break;
		}

		return state;
	};

	/*
	 * What do I display? Final? Final/7? Final/9? Just tell me...
	 */
	exports.getDisplayFinalState = function(gameState, scheduledInnings, inningsPlayed) {
		if(GameStates.COMPLETED_EARLY == gameState || (GameStates.FINAL == gameState && scheduledInnings != inningsPlayed)) {
			return "Final/" + inningsPlayed;
		} else if (GameStates.FINAL == gameState) {
			return "Final";
		}
	};

	exports.getDisplayFinalStateShort = function(gameState, scheduledInnings, inningsPlayed) {
		if(GameStates.COMPLETED_EARLY == gameState || (GameStates.FINAL == gameState && scheduledInnings != inningsPlayed)) {
			return "F/" + inningsPlayed;
		}
		return "F";
	};

	exports.isValidState = function(state){
		var isValid=false,
			val;
		for( val in GameStates){
			if(GameStates[val]===state){
				return true;
			}
		}
		return false;
	};

	exports.setGameState = function(state){
		state = state && this.isValidState(state) ? state : this.getUsableGameState();
		UrlHasher.setHashParams({
			game_state : state
		});
	};

	exports.getAbstractGamestate = function(fullGamestate) {

		switch (fullGamestate) {
			//live
			case GameStates.IN_PROGRESS:
			case GameStates.WARMUP:
			case GameStates.REPLAY:
			case GameStates.LIVE:
				return GameStates.ABSTRACT_LIVE;
				break;

			//pregame
			case GameStates.PREVIEW:
			case GameStates.PREGAME:
			case GameStates.LINEUPS:
				return GameStates.ABSTRACT_PREGAME;
				break;

			//delayed
			case GameStates.DELAYED:
			case GameStates.DELAYED_START:
			case GameStates.REVIEW:
			case GameStates.CHALLENGE:
				return GameStates.ABSTRACT_DELAYED;
				break;

			//final
			case GameStates.FINAL:
			case GameStates.GAME_OVER:
			case GameStates.COMPLETED_EARLY:
				return GameStates.ABSTRACT_FINAL;
				break;

			//other
			case GameStates.SUSPENDED:
			case GameStates.POSTPONED:
			case GameStates.FORFEIT:
			case GameStates.CANCELLED:
			default:
				return GameStates.ABSTRACT_OTHER;
				break;
		}
	};
});
